import PropTypes from 'prop-types';

const ButtonContainer = ({ children, width = '100%', containerWidth = '100%', align = true }) => {
    return (
        <div style={{ display: 'flex', justifyContent: align ? 'center' : 'left', width: containerWidth }}>
            <div style={{ width: width }}>{children}</div>
        </div>
    );
};

ButtonContainer.propTypes = {
    children: PropTypes.element.isRequired,
    width: PropTypes.string,
    containerWidth: PropTypes.string,
    align: PropTypes.bool
};

export default ButtonContainer;
